import { render, staticRenderFns } from "./ExtendHandle.vue?vue&type=template&id=58221dd0"
import script from "./ExtendHandle.vue?vue&type=script&lang=js"
export * from "./ExtendHandle.vue?vue&type=script&lang=js"
import style0 from "./ExtendHandle.vue?vue&type=style&index=0&id=58221dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports